// Routes
import coreWebsiteRoutes from '../../core-website/routes';

export default {
	home: {
		...coreWebsiteRoutes.home,
		head: {
			title: 'Dijital dönüşümde taze bir bakış açısı',
		},
	},
	notFound: coreWebsiteRoutes.notFound,
	error: coreWebsiteRoutes.error,
};
